const PlayBotsIcon: React.FC = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21 12H3C1.89543 12 1 12.8954 1 14V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V14C23 12.8954 22.1046 12 21 12Z"
            fill="#49DAFF"
        />
        <path d="M13 5.08008H11V11.0801H13V5.08008Z" fill="#1C3D5B" />
        <path
            d="M12 7.16992C13.6569 7.16992 15 5.82678 15 4.16992C15 2.51307 13.6569 1.16992 12 1.16992C10.3431 1.16992 9 2.51307 9 4.16992C9 5.82678 10.3431 7.16992 12 7.16992Z"
            fill="#49DAFF"
        />
        <path
            d="M2 18V14C2 13.45 2.45 13 3 13H21C21.29 13 21.55 13.13 21.74 13.34L22.45 12.63C22.09 12.25 21.57 12 21 12H3C1.9 12 1 12.9 1 14V18C1 18.54 1.22 19.03 1.57 19.39L2.28 18.68C2.11 18.5 2 18.26 2 18Z"
            fill="#B2FDFF"
        />
        <path
            d="M17 9H7C4.79086 9 3 10.7909 3 13V19C3 21.2091 4.79086 23 7 23H17C19.2091 23 21 21.2091 21 19V13C21 10.7909 19.2091 9 17 9Z"
            fill="#49DAFF"
        />
        <path
            d="M11 4.16992C11.5523 4.16992 12 3.72221 12 3.16992C12 2.61764 11.5523 2.16992 11 2.16992C10.4477 2.16992 10 2.61764 10 3.16992C10 3.72221 10.4477 4.16992 11 4.16992Z"
            fill="#B2FDFF"
        />
        <path
            d="M8 17C9.10457 17 10 16.1046 10 15C10 13.8954 9.10457 13 8 13C6.89543 13 6 13.8954 6 15C6 16.1046 6.89543 17 8 17Z"
            fill="#157A9C"
        />
        <path
            d="M16 17C17.1046 17 18 16.1046 18 15C18 13.8954 17.1046 13 16 13C14.8954 13 14 13.8954 14 15C14 16.1046 14.8954 17 16 17Z"
            fill="#157A9C"
        />
        <path
            d="M17 9.00023H7C4.79 9.00023 3 10.7902 3 13.0002V19.0002C3 20.0502 3.41 21.0002 4.08 21.7102L4.79 21.0002C4.31 20.4702 4.01 19.7702 4.01 19.0002V13.0002C4.01 11.3502 5.36 10.0002 7.01 10.0002H17.01C17.9 10.0002 18.7 10.4002 19.25 11.0202L19.96 10.3102C19.23 9.51024 18.18 8.99023 17.01 8.99023L17 9.00023Z"
            fill="#B2FDFF"
        />
    </svg>
)

PlayBotsIcon.displayName = 'PlayBotsIcon'

export default PlayBotsIcon
